module.exports = __webpack_public_path__ + "static/media/Vortex-4WD-OV-5300-SW.230f0d1e.png";